<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 20px 20px 0;">
        <baidu-map
            class="map"
            :center="centerName"
            :zoom="15"
            @click="getClickInfo"
            :scroll-wheel-zoom="true"
            :mapClick="false"
        >
          <bm-marker
              :position="center"
              animation="BMAP_ANIMATION_BOUNCE">
          </bm-marker>
          <bm-control :offset="{ width: '10px', height: '10px'}">
            <bm-auto-complete v-model="addressInfo" :sugStyle="{ zIndex: 999999 }">
              <el-input v-model="addressInfo" placeholder="请输入搜索关键字" style="margin:10px 0 0 10px">
                <template slot="prepend"><span>地址搜索：</span></template>
              </el-input>
            </bm-auto-complete>
          </bm-control>
          <bm-local-search
              :keyword="addressInfo"
              :auto-viewport="true"
              style="width:0px;height:0px;overflow: hidden;">
          </bm-local-search>
          <bm-circle
              v-model="circlePath.radius"
              :center="circlePath.centerStr"
              :radius="circlePath.radius"
              stroke-color="blue"
              :stroke-opacity="0.5"
              :stroke-weight="2"
              @lineupdate="updateCirclePath"
          >
          </bm-circle>
        </baidu-map>
      </div>
      <div class="modal-footer">
        <el-row style="width:100%">
          <el-col :span="21">
            <el-col :span="12" style="padding:0 5px ">
              <el-input type="number"   v-model="circlePath.radius" >
                <template slot="prepend"><span>半径范围：</span></template>
                <template slot="append"><span>米</span></template>
              </el-input>
            </el-col>
            <el-col :span="12" style="padding:0 20px ">
              <span>报警类型：</span>
              <el-select v-model="warning" placeholder="请选择报警类型"
                         style="width:70%" clearable>
                <el-option
                    v-for="item in warningValue"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="24 " style="padding:10px 5px ">
              <span>地址：</span>
              <el-input v-model="address" :disabled='true' style="width:70%"></el-input>
            </el-col>

          </el-col>
          <el-col :span="3">
            <el-button style="float: right;margin-right:10px" type="primary" @click="submit">提交</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
</template>

<script>


import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "addHospital",
  data() {
    return {
      userCode:'',
      warning: '',
      warningValue: [{
        value: 'out', label: '出'
      }, {
        value: 'in', label: '进'
      }],
      centerName:{
        lng: '',
        lat: ''
      },
      center: {
        lng: '',
        lat: ''
      },
      addressInfo:'',
      zoom: '',
      circlePath:{
        centerStr: {
          lng: '',
          lat: ''
        },
        radius:''
      },
      address:'',



    };
  },
  components: {

  },
  methods: {
    init(userCode) {
      this.userCode=userCode;
      this.circlePath.radius='';
      this.warning='';
      this.center.lat='';
      this.center.lng='';
      this.circlePath.centerStr=this.center;
      this.centerName='合肥市';
      this.addressInfo='';
      this.address='';
      this.getWeiLanInfo();
      this.getWeiLanInfo();

    },

    closeSelf() {
      this.$emit('closeBaiduMapRail')
    },
    getClickInfo(e){
      this.center.lng=e.point.lng;
      this.center.lat=e.point.lat;
    },
    updateCirclePath(){
        this.circlePath.centerStr = this.center;
    },
    getWeiLanInfo(){
      this.$axios({
        method: 'post',
        url: this.$institutionUrl + "Positioning/WeiLanInfo",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode:this.userCode,
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              if(response.data.data!==null){
                this.circlePath.radius=response.data.data.Distance*1000;
                this.warning=response.data.data.AlertType;
                this.center.lat=response.data.data.Lat;
                this.center.lng=response.data.data.Lon;
                this.circlePath.centerStr=this.center;
                this.centerName='合肥市';
                this.address=response.data.data.Address
              }else {
                this.circlePath.radius='';
                this.centerName='合肥市';
              }
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    submit(){
      if(this.circlePath.radius===''){
        this.$message({type: 'info', message: '请设置半径!'});
      }
      if(this.center.lat===''||this.center.lng===''){
        this.$message({type: 'info', message: '请选择具体位置!'});
      }

      this.$axios({
        method: 'post',
        url: this.$institutionUrl + "Positioning/WeiLan",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode:this.userCode,
          lat:this.center.lat,
          lon:this.center.lng,
          distance:this.circlePath.radius/1000,
          tag:this.warning
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              console.log(response.data.data)
              this.$message({type: 'success', message: '保存成功'});
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

  }
};

</script>

<style>

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"]{
  -moz-appearance: textfield;
}


</style>



<style lang="scss" scoped>
.map{
  width: 100%;
  height: 400px;
}
.modal-footer {
  border-top: 1px solid #eee;
  // justify-content: flex-end;
  padding: 15px;
  // display: flex;
}

/deep/ .el-input.is-disabled .el-input__inner{
  background-color: #fff;
  border-color: #DCDFE6;
  color:#606266;
  cursor: not-allowed;
}

</style>
